module.exports = __webpack_public_path__ + "static/media/bacteria.ef94c9ba.png";